import React from "react";
import { trackEvent } from "../../../../helpers/analyticsHelper";
import { PAGE_EVENT_NAMES, WIDGETS } from "../../../../constants/common";

class DisaggHeader extends React.Component {
  playDisagVideo(){
    trackEvent(this.props.userObj.details.uuid, PAGE_EVENT_NAMES.FAQ, {
      clicked : "FAQ video"
    })
  }

  render () {
  let elecHead = this.props.translations.data["DISAGG101_AIE.HEADLINE"];
  let gasHead = this.props.translations.data["DISAGG101_FAQ.HEADLINE"];
  let elecSubHead = this.props.translations.data["DISAGG101_AIE.SUB_HEADLINE"];
  let gasSubHead = this.props.translations.data["DISAGG101_FAQ.SUB_HEADLINE"];
  const elecVideo = () =>{
    return(
      <>
      <div className="video">
          <video controls className="video-image" poster={this.props.configs.data["disagg101.video_image"]} onClick={()=>this.playDisagVideo()}>
            <source
              src={this.props.configs.data["disagg101.cat_video"]}
              type="video/mp4"
            />
          </video>
        </div>
        </>
    )
  }
  return (
    <div className="disagg-header-container">
      <div className="disagg-header">
        <h1 className="title"><span data-widget-name={WIDGETS.FAQ} data-text-color="color_2">{(this.props.configs.data["disagg101.utilitytype"] === 'electric' ? elecHead : gasHead )}</span></h1>
        <p className="text">
        <span data-widget-name={WIDGETS.FAQ} data-text-color="color_3">{(this.props.configs.data["disagg101.utilitytype"] === 'electric' ? elecSubHead : gasSubHead )}</span>
        </p>
      </div>
      <div className="disagg-media">
        <img className="disagglogo" src={this.props.configs.data["disagg101.disagg_image"]}  alt="logo" />
        {this.props.configs.data["disagg101.utilitytype"] === 'electric' && this.props.configs.data["disagg101.showVideoLink"] == "true" ? elecVideo() : ""}
      </div>
    </div>
  );
}
}

export default DisaggHeader;
